export { default } from './EndpageHeader';
export type { Props as EndpageHeaderProps } from './EndpageHeader';
